import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlHelperService } from '@core/services/url-helper.service';
import { ItemSearchResult } from '@shared/interfaces/gridrows/item-search-result.interface';
import { BooleanResult } from '@core/interfaces/boolean-result.interface';
import { Cart } from '../../../core/interfaces/cart.interface';
import { Item } from '../../../shared/interfaces/entities/item.interface';
import { ImageEntity } from "../../../shared/interfaces/entities/image.interface";
import { MiscellaneousItemSearchResult } from '../../../shared/interfaces/gridrows/miscellaneous-item-search-result.interface';
import { AuditTypeSearchResult } from '../../../shared/interfaces/gridrows/audit-type-search-result.interface';
import { AuthenticationService } from '../../../core/services/authentication.serivce';

@Injectable({
  providedIn: 'root'
})

export class MiscellaneousItemService {
  items: Cart[] = [];
  constructor(private http: HttpClient,
              private urlHelper: UrlHelperService,
              private auth: AuthenticationService) {

    //public state: State = { skip: 0, take: 100 };
  }

  getMiscellaneousItemOptions(): Observable<MiscellaneousItemSearchResult> {
    var postData: { [k: string]: any } = {};
    postData['skip'] = 0;
    postData['take'] = 100;
    var url = this.urlHelper.getApiUrl() + "MiscellaneousItem";
    return this.http.post<MiscellaneousItemSearchResult>(url, postData);
  }

  getDefaultAuditType(): Observable<AuditTypeSearchResult> {
    var postData: { [k: string]: any } = {};
    postData['organizationId'] = this.auth.getOrganizationId();

    var url = this.urlHelper.getApiUrl() + "MiscellaneousItem/GetDefaultAuditType/?organizationId=" + this.auth.getOrganizationId();
    return this.http.get<any>(url);
  }
}
